module.exports = "<itpx-learning-tile [deliverableStatus]=\"deliverableStatus\" [status]=\"status\" [target]=\"target\" [logo]=\"'elearning.png'\"\n                    [name]=\"name\" [errorMessage]=\"errorMessage\" [disabled]=\"deliverable.disabled\"\n                    [availableUntil]=\"deliverable.availableUntil\" [deliverable]=\"deliverable\">\n\n  <links-section>\n    <a class=\"link-wrapper\" [href]=\"href\">\n      <i class=\"link-action fa fa-eye\"></i>\n    </a>\n  </links-section>\n\n</itpx-learning-tile>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/content/google-slides/tile.component.html
// module id = 860
// module chunks = 0